import { render, staticRenderFns } from "./ViewSyncLogComponent.vue?vue&type=template&id=4796ca51&"
import script from "./ViewSyncLogComponent.vue?vue&type=script&lang=js&"
export * from "./ViewSyncLogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports